/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ actor: NonNullable<unknown> }} Orders_Tracking_Audit_ByInputs */

const en_orders_tracking_audit_by = /** @type {(inputs: Orders_Tracking_Audit_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set by ${i?.actor}`)
};

const es_orders_tracking_audit_by = /** @type {(inputs: Orders_Tracking_Audit_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Establecido por ${i?.actor}`)
};

/**
* | output |
* | --- |
* | "Set by {actor}" |
*
* @param {Orders_Tracking_Audit_ByInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_tracking_audit_by = /** @type {((inputs: Orders_Tracking_Audit_ByInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Tracking_Audit_ByInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_tracking_audit_by(inputs)
	return es_orders_tracking_audit_by(inputs)
});